import { csrfHeader } from '../utils/csrf';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3002/api';

type EventProperties = Record<string, string | number | boolean | null | undefined>;

const FIRST_TOUCH_KEY = 'luma_first_touch';

// Records where a visitor first came from (external referrer host + utm params) so the
// auth event can say which channel produced the user. Stored once; later visits don't overwrite.
export function captureFirstTouch(): void {
  try {
    if (localStorage.getItem(FIRST_TOUCH_KEY)) return;
    const params = new URLSearchParams(window.location.search);
    let referrerHost = '';
    try { referrerHost = document.referrer ? new URL(document.referrer).hostname : ''; } catch { /* ignore */ }
    if (referrerHost === window.location.hostname) referrerHost = '';
    localStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify({
      ref: referrerHost || 'direct',
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      landing: window.location.pathname,
    }));
  } catch { /* storage unavailable */ }
}

export function getFirstTouch(): EventProperties {
  try {
    return JSON.parse(localStorage.getItem(FIRST_TOUCH_KEY) || '{}');
  } catch {
    return {};
  }
}

export function trackEvent(name: string, properties?: EventProperties): void {
  // Only track for logged-in users. Auth now rides on the httpOnly session cookie (not
  // readable here), so `user` in localStorage — the local UI cache, not a credential —
  // is used as a lightweight presence check instead of the old token check.
  if (!localStorage.getItem('user')) return;
  fetch(`${API_URL}/analytics/event`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...csrfHeader() },
    body: JSON.stringify({ name, properties: properties ?? {} }),
  }).catch(() => {});
}
